module.exports = __webpack_public_path__ + "img/Search.183306fc.svg";